import { GzIndicatorsOfRiskGeneralWebComponent } from './component/GzIndicatorsOfRiskGeneralWebComponent';

export { GzIndicatorsOfRiskGeneralWebComponent };
